import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
import { useDynamicScripts } from "../../hooks/useDynamicScript";
import { postConvergenceAnonymousFormSubmit } from "../../redux/slice/convergence/convergence-anonymous-form-submit-slice";
import { retrievePageMenu } from "../../redux/slice/page-menu.slice";
import { RootState, useAppDispatch } from "../../redux/store";
import Convergence2023Banner from "./components/convergence-2023-banner";

const Convergence2023CodeOfConductIncidentReport = () => {
  const path = "Convergence-2023%2FCode-of-Conduct-Incident-Report";
  const dispatch = useAppDispatch();
  const { RapsEuropeData: pageMenuData } = useSelector((state: RootState) => state.rapsEurope);
  const [incidentDescription, setIncidentDescription] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [isEmail, setIsEmail] = useState<boolean>(false);
  const [email, setEmail] = useState<string>("");
  const [phoneNo, setPhoneNo] = useState<string>("");
  const [checkbox, setCheckbox] = useState<boolean>(false);
  const [isValidate, setIsValidate] = useState<boolean>(false);
  const [SuccessMsg, setSuccessMsg] = useState<boolean>(false);

  useEffect(() => {
    dispatch(retrievePageMenu(`%2F${path}`));
  }, [dispatch]);

  const handleSubmit = (e: React.MouseEvent<HTMLInputElement, MouseEvent>) => {
    e.preventDefault();

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(email)) {
      setIsEmail(true);
      return;
    } else {
      setIsEmail(false);
    }

    if (incidentDescription.trim() === "") {
      setIsValidate(true);
      return;
    } else {
      setIsValidate(false);
    }

    // form is valid, submit the data
    dispatch(
      postConvergenceAnonymousFormSubmit({
        incidentDescription: incidentDescription,
        name: name,
        email: email,
        phoneNumber: phoneNo,
        consent: checkbox,
      })
    );

    setIsValidate(false);
    setSuccessMsg(true);
  };

  // Dynamic Scripts
  const [scriptHtmlString, setScriptHtmlString] = useState("");

  useEffect(() => {
    if (pageMenuData[0]?.result[0]) {
      if (pageMenuData[0]?.result[0].javaScriptField) {
        setScriptHtmlString(pageMenuData[0].result[0].javaScriptField);
      }

      if (window.runGlobalScripts) {
        window.runGlobalScripts();
      }
    }
  }, [pageMenuData]);

  useDynamicScripts({ htmlScriptString: scriptHtmlString, divId: "convergence-2023-code-of-conduct-incident-report-script" });
  // End Dynamic Scripts

  return (
    <>
      <Convergence2023CodeOfConductIncidentReportStyleComponent />
      <Helmet>
        <title>{pageMenuData[0]?.result[0]?.menuItemName}</title>
      </Helmet>
      <Convergence2023Banner
        bannerImage={pageMenuData[0]?.result[0]?.mainHeaderImage}
        mobileBanner={pageMenuData[0]?.result[0]?.mobileHeaderImage}
        headerText={pageMenuData[0]?.result[0]?.headerText}
        topCommonMesage={pageMenuData[0]?.result[0]?.topCommonMesage}
      />
      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <div id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz">
              <div id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_pM_pMP">
                {isValidate ? (
                  <span id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_pM_lE" className="ErrorLabel">
                    The entered values cannot be saved. Please see the fields below for details.
                  </span>
                ) : (
                  ""
                )}
                {SuccessMsg ? (
                  <span id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_pM_lE">
                    Thank you for taking the time to bring this matter to our attention. We will investigate to the best of our ability.
                  </span>
                ) : (
                  ""
                )}
              </div>
              {!SuccessMsg && (
                <div id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_pnlForm" className="FormPanel">
                  <table className="form-table">
                    <tbody>
                      <tr>
                        <td colSpan={3}>
                          <p>
                            Please provide as many details as possible. If known, please state the date/time and location of the incident, and the identity of victims, responsible individuals, and
                            witnesses so that we may fully investigate this issue.
                          </p>
                        </td>
                      </tr>
                      <tr className="form-table-group">
                        <td className="form-table-label-cell">
                          <label
                            id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_Description_lb"
                            className="EditingFormLabel"
                            htmlFor="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_Description_txtText"
                          >
                            Incident Description:
                          </label>
                        </td>
                        <td className="form-table-value-cell">
                          <div id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_ncpdescription" className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <textarea
                              name="p$lt$ctl01$SiteMainPlaceholder$p$lt$ctl01$BizForm$viewBiz$Description$txtText"
                              rows={2}
                              cols={20}
                              id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_Description_txtText"
                              className="form-control"
                              value={incidentDescription}
                              onChange={(e) => setIncidentDescription(e.target.value as string)}
                            ></textarea>
                          </div>
                        </td>
                        {isValidate ? <td className="form-table-validation-cell ErrorLabel">Please enter a value.</td> : ""}
                      </tr>
                      <tr className="form-table-group">
                        <td colSpan={3}>
                          <p>
                            Please note this form is anonymous. We will investigate to the best of our ability but actions may be limited without being able to follow-up further. We encourage you to
                            identify yourself to facilitate any follow-up and response to your questions.
                          </p>
                        </td>
                      </tr>
                      <tr className="form-table-group">
                        <td className="form-table-label-cell">
                          <label
                            id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_Name_lb"
                            title="If you would like to be contacted for follow-up, please provide your contact information."
                            className="EditingFormLabel"
                            htmlFor="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_Name_txtText"
                          >
                            (Optional) Name:
                          </label>
                        </td>
                        <td className="form-table-value-cell">
                          <div id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_ncpname" className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input
                              name="p$lt$ctl01$SiteMainPlaceholder$p$lt$ctl01$BizForm$viewBiz$Name$txtText"
                              type="text"
                              maxLength={200}
                              id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_Name_txtText"
                              className="form-control"
                              value={name}
                              onChange={(e) => setName(e.target.value as string)}
                            />
                          </div>
                        </td>
                        <td className="form-table-validation-cell"></td>
                      </tr>
                      <tr className="form-table-group">
                        <td className="form-table-label-cell">
                          <label
                            id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_Email_lb"
                            className="EditingFormLabel"
                            htmlFor="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_Email_txtEmailInput"
                          >
                            (Optional) Email:
                          </label>
                        </td>
                        <td className="form-table-value-cell">
                          <div id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_ncpemail" className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input
                              name="p$lt$ctl01$SiteMainPlaceholder$p$lt$ctl01$BizForm$viewBiz$Email$txtEmailInput"
                              type="text"
                              maxLength={254}
                              id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_Email_txtEmailInput"
                              className="form-control"
                              value={email}
                              onChange={(e) => setEmail(e.target.value as string)}
                            />
                            <span id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_Email_revEmailValid" className="form-control-error" style={{ display: "none" }}></span>
                          </div>
                        </td>
                        <td className="form-table-validation-cell"></td>
                      </tr>
                      <tr className="form-table-group">
                        <td className="form-table-label-cell">
                          <label
                            id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_Phone_lb"
                            className="EditingFormLabel"
                            htmlFor="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_Phone_txtText"
                          >
                            (Optional) Phone Number:
                          </label>
                        </td>
                        <td className="form-table-value-cell">
                          <div id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_ncpphone" className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <input
                              name="p$lt$ctl01$SiteMainPlaceholder$p$lt$ctl01$BizForm$viewBiz$Phone$txtText"
                              type="text"
                              maxLength={200}
                              id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_Phone_txtText"
                              className="form-control"
                              value={phoneNo}
                              onChange={(e) => setPhoneNo(e.target.value)}
                            />
                          </div>
                        </td>
                        <td className="form-table-validation-cell"></td>
                      </tr>
                      <tr className="form-table-group">
                        <td className="form-table-value-cell">
                          <div id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_ncpconsent" className="EditingFormControlNestedControl editing-form-control-nested-control">
                            <span className="CheckBoxField checkbox">
                              <input
                                id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_Consent_checkbox"
                                type="checkbox"
                                name="p$lt$ctl01$SiteMainPlaceholder$p$lt$ctl01$BizForm$viewBiz$Consent$checkbox"
                                checked={checkbox}
                                onChange={(e) => setCheckbox(e.target.checked)}
                              />
                              <label htmlFor="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_Consent_checkbox">&nbsp;</label>
                            </span>
                          </div>
                        </td>
                        <td className="form-table-label-cell" colSpan={2}>
                          By submitting this form, I provide consent that my entry will be stored with RAPS for the purpose of doing business with RAPS. If contact details are provided, I consent to
                          receiving communications from RAPS related to this report and that I can opt-out at any time by contacting RAPS or updating preferences. <br /> I also hereby understand and
                          agree to the privacy policy provided on RAPS.org.{" "}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <input
                    type="submit"
                    name="p$lt$ctl01$SiteMainPlaceholder$p$lt$ctl01$BizForm$viewBiz$btnOK"
                    value="Submit"
                    id="p_lt_ctl01_SiteMainPlaceholder_p_lt_ctl01_BizForm_viewBiz_btnOK"
                    className="FormButton btn btn-primary"
                    onClick={(e) => handleSubmit(e)}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Convergence2023CodeOfConductIncidentReport;

const Convergence2023CodeOfConductIncidentReportStyleComponent = () => {
  return (
    <>
      <style>
        {`
          table{
            margin-top: 0;
          }
          table td{
            border-color: transparent;
            padding: 0;
            font-size: 1rem;
          }
          label{
            font-weight: 300;
          }
          .checkbox input[type=checkbox], .checkbox-inline input[type=checkbox], .radio input[type=radio], .radio-inline input[type=radio]{
            margin-left: 0px;
          }
          .ErrorLabel{
            color: red;
          }
        `}
      </style>
    </>
  );
};
